import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scrollTop } from "../../helpers/behavior";
import "./style.css";
import Loading from "../Loading";
import { isBrowser, isMobile } from "react-device-detect";

export default function PodcastBrand({ item, windowSize }) {
	const description = item.description;
	let podcastDescription;
	if (typeof description === "string") {
		podcastDescription = description.substring(0, 20) + "...";
	}
	const [loading, setLoading] = useState(true);
	const [invalid, setInvalid] = useState(false);
	const navigate = useNavigate();
	const itemToDisplay = 9;
	const marginBrand = 12;
	const margeToSupp = 14;
	let podcastSize;
	if (isBrowser) {
		//en cas de format desktop rendre les vignettes proportionnelles
		podcastSize = windowSize / itemToDisplay - margeToSupp;
	} else if (windowSize < 993 && windowSize >= 769 && isMobile) {
		podcastSize = 140;
	} else if (windowSize < 769 && isMobile) {
		podcastSize = 100;
	} else {
		throw new Error("windowSize anormal");
	}
	useEffect(() => {
		scrollTop();
	}, []);
	const handleOnClick = (idseries) => {
		navigate(`/podcast/${idseries}`);
	};
	return (
		<div>
			<div
				id={`podcast${item?.rpId}`}
				className={`podcastBrand`}
				style={{
					backgroundImage: `url(${item?.imageUrl})`,
					width: podcastSize,
					height: podcastSize,
					margin: `0 0 0 ${marginBrand}px`,
				}}
				onClick={(e) => handleOnClick(item.idseries)}
			>
				<img
					alt={item.title}
					src={item?.imageUrl}
					onLoad={() => setLoading(false)}
					onError={() => setInvalid(true)}
				/>
				<Loading
					size={30}
					color="red"
					conClass="podcastItemLoading"
					style={{ opacity: loading && !invalid ? 1 : 0, width: podcastSize, height: podcastSize }}
				/>
			</div>
			<div className="podcastBrandTitle ms-1 fw-bold" style={{ width: podcastSize }}>
				{item.title}
			</div>
			<div className="podcastBrandDescr ms-1" style={{ width: podcastSize }}>
				{podcastDescription}
			</div>
		</div>
	);
}
